<div *ngIf="contractInformationLoaded">
    <!-- Contenedor limitado y centrado -->
    <div class="max-w-screen-xl mx-auto px-2 md:px-4 lg:p-8 py-6 bg-gray-50 flex flex-col gap-6">
        <div class="grid grid-cols-12 bg-white p-4 md:p-8 gap-y-8 gap-x-4">
            <div class="full-w col-span-12">
                <!-- signservice : document title -->
                <div class="typography-title-m mb-1">{{'contract.sign_contract' | translate}}</div>
                <div class="divider mb-2"></div>
            </div>
            <div class="full-w col-span-12 px-4 md:px-10 lg:px-20">
                <p class="m-0 mb-6 typography-body-m-light">
                    {{ 'contract.review_the_contract_and_accept_the_terms_and_conditions' | translate }}
                </p>
                <div class="grid grid-cols-[repeat(3,1fr)] gap-4 lg:gap-8">
<!--                    Contract information-->
                    <div
                        class="w-full col-span-3 lg:col-span-1"
                        style="padding: 24px; background: #bde2ec; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 16px; display: inline-flex;height:fit-content"
                    >
                        <div style="align-self: stretch; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 8px; display: flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem" viewBox="0 0 24 24" fill="none" style="vertical-align: middle">
                                <path
                                    class="primaryDefault"
                                    d="M11.5 16.5H12.5V11H11.5V16.5ZM12 9.575C12.1667 9.575 12.3127 9.51667 12.438 9.4C12.5627 9.28333 12.625 9.13333 12.625 8.95C12.625 8.78333 12.5627 8.64167 12.438 8.525C12.3127 8.40833 12.1667 8.35 12 8.35C11.8333 8.35 11.6873 8.40833 11.562 8.525C11.4373 8.64167 11.375 8.78333 11.375 8.95C11.375 9.13333 11.4373 9.28333 11.562 9.4C11.6873 9.51667 11.8333 9.575 12 9.575ZM12 21C10.75 21 9.57933 20.7627 8.488 20.288C7.396 19.8127 6.446 19.1707 5.638 18.362C4.82933 17.554 4.18733 16.604 3.712 15.512C3.23733 14.4207 3 13.25 3 12C3 10.75 3.23733 9.579 3.712 8.487C4.18733 7.39567 4.82933 6.44567 5.638 5.637C6.446 4.829 7.396 4.18733 8.488 3.712C9.57933 3.23733 10.75 3 12 3C13.25 3 14.421 3.23733 15.513 3.712C16.6043 4.18733 17.5543 4.829 18.363 5.637C19.171 6.44567 19.8127 7.39567 20.288 8.487C20.7627 9.579 21 10.75 21 12C21 13.25 20.7627 14.4207 20.288 15.512C19.8127 16.604 19.171 17.554 18.363 18.362C17.5543 19.1707 16.6043 19.8127 15.513 20.288C14.421 20.7627 13.25 21 12 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                                    fill="#232323"
                                />
                            </svg>
                            <div style="align-self: stretch; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 8px; display: flex">
                                <div
                                    class="typography-title-m"
                                    style="align-self: stretch; color: #323232; font-size: 20px; font-family: Diagramm; font-weight: 500; line-height: 24px; word-wrap: break-word"
                                >
                                    {{ 'contract.remember_you_must_sign_the_contract' | translate }}
                                </div>
                                <div class="typography-body-l-regular" style="align-self: stretch; color: #323232; word-wrap: break-word">
                                    {{'contract.if_you_have_questions_please_ask_your_manager' | translate}}
                                </div>
                                <div class="flex self-stretch mt-4">
                                    <div class="flex-1">
                                        <app-button [isFullWidth]="true" [size]="'large'" (onClick)="openContact()">
                                            {{ 'my_customers.contact' | translate }}
                                        </app-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
<!--                    Iframe with contract-->
                    <div class="col-span-3 lg:col-span-2">
                        <div class="scrollable w-full h-[430px] p-2 border border-dashed border-primary" style="background-color: #D2E1E8">
                            <ng-container *ngIf="shouldLoadInIframe">
                                <iframe
                                    [src]="iframeUrl"
                                    width="100%"
                                    height="414"
                                    frameborder="0"
                                ></iframe>
                            </ng-container>
                            <ng-container *ngIf="!contractUrl.includes('forms.cosentino.com')">
                                <pdf-viewer
                                    class="pdf-viewer w-full h-full"
                                    [src]="contractUrl"
                                    [style]="{}"
                                    [stick-to-page]="true"
                                    [render-text]="true"
                                    [zoom-scale]="'page-width'"
                                    [zoom]="1"
                                    [original-size]="false"
                                    [autoresize]="true"
                                    (after-load-complete)="documentLoaded = true"
                                />
                            </ng-container>
                        </div>

                        <!-- Terms and Conditions -->
                        <div [ngClass]="{'invisible': !documentLoaded}" class="mt-4 col-span-12">
                            <label class="marginComponents flex items-center text-sm w-full">
                                <app-checkbox [checked]="acceptTerms" (checkboxChange)="acceptTerms = $event" class="mr-2" />
                                <span class="typography-body-m-regular">{{ 'my_sales.accept_terms_label' | translate }}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--        Buttons to navigate between tabs and save the draft-->
        <div class="p-8 bg-white border-divider border flex flex-wrap gap-3 justify-center items-center">
                <div *ngIf="!isSignable">
                    <alert type="error">
                        <p class="m-0 mt-0.5 typography-body-m-regular">
                            {{'contract.only_the_primary_contact_can_sign_the_contract' | translate}}
                        </p>
                    </alert>
                </div>

                <div class="basis-full md:basis-0">
                    <!-- sign service: on sign; -->
                    <div class="flex flex-wrap md:flex-nowrap justify-center gap-4">
                        <app-button
                            *ngIf="true"
                            [primary]="false"
                            [block]="true"
                            [textWrap]="false"
                            (onClick)="goHome()"
                        >{{'my_galleries.volver1' | translate}}</app-button>
                        <app-button
                            *ngIf="true"
                            [primary]="true"
                            [block]="true"
                            [textWrap]="false"
                            [disabled]="!acceptTerms || !isSignable"
                            (onClick)="signContract()"
                        >{{'contract.sign_contract' | translate}}</app-button>
                    </div>
                </div>
        </div>
    </div>
</div>

<app-confirm-modal
    [isOpen]="showContactModal"
    [title]="'home.contact_information' | translate"
    [confirmText]="''"
    [cancelText]="'common.buttons.close' | translate"
    (onCancel)="showContactModal = false"
    (onClose)="showContactModal = false"
>
    <div class="grid grid-cols-[repeat(2,1fr)] md:grid-cols-[repeat(3,1fr)] gap-4">
        <span class="typography-body-l-regular col-span-1">
            {{'my_profile.name_label' | translate}}
        </span>
        <span class="typography-body-m-medium col-span-1 md:col-span-2">
            {{userInfo.accountOwnerFullName}}
        </span>

        <span class="typography-body-l-regular col-span-1">
            {{'my_profile.email_label' | translate}}
        </span>
        <span class="typography-body-m-medium col-span-1 md:col-span-2">
            {{userInfo.accountOwnerEmail}}
        </span>
    </div>

</app-confirm-modal>
